import { render, staticRenderFns } from "./updateNotice.vue?vue&type=template&id=72b3c638&scoped=true"
import script from "./updateNotice.vue?vue&type=script&lang=js"
export * from "./updateNotice.vue?vue&type=script&lang=js"
import style0 from "./updateNotice.vue?vue&type=style&index=0&id=72b3c638&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b3c638",
  null
  
)

export default component.exports